import styled from 'styled-components';

import { useProfile } from 'context/profile';
import useIsMobile from 'hooks/useIsMobile';
import PersonaIcon from 'svg/PersonaIcon';

export function PersonaCallingCard() {
  const { profile } = useProfile();
  const isMobile = useIsMobile();

  if (isMobile || !profile?.demoPersona) {
    return null;
  }

  return (
    <PersonaContainer data-cy='PersonaCallingCard'>
      <ContentWrapper>
        <StyledPersonaIcon />
        <TextContainer>
          <Label>Currently viewing as:</Label>
          <PersonaName>{profile.demoPersona}</PersonaName>
        </TextContainer>
      </ContentWrapper>
    </PersonaContainer>
  );
}

const PersonaContainer = styled.div`
  position: fixed;
  bottom: 32px;
  left: 32px;
  padding: 24px;
  height: 80px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black10};
  border-radius: 4px;
  z-index: 1000;
  box-sizing: border-box;
  min-width: 240px;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
`;

const StyledPersonaIcon = styled(PersonaIcon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.primaryBlue};
  flex-shrink: 0;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 12px;
  font-weight: normal;
  line-height: 1;
`;

const PersonaName = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
`;
